import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import PageLoader from '../../../../components/PageLoader/PageLoader';
import OrganisationMainSection from '../../../../components/OrganisationMainSection/OrganisationMainSection';
import StrategicThirdPartyActionBar from './components/StrategicThirdPartyActionBar';
import StrategicThirdPartyClass from './components/StrategicThirdPartyClass';
import * as actions from './StrategicThirdPartyAction';
import { orgIdSelector } from '../../OrganisationSelectors';
import {
  strategicThirdPartyListSelector,
  strategicThirdPartyCategoriesSelector,
  loadingStrategicThirdPartySelector
} from './StrategicThirdPartySelectors';

const CLASS_NAME = 'Strategic Third Parties';

const TOOLTIP_DETAIL = (
  <p>
    Strategic Third Parties are external organisations that may be required following an event. Some recommended Strategic
    Third Parties have been included but can be deleted (or changed) if not required.
  </p>
);

const GUIDANCE = (
  <>
    <strong>What to do:</strong> tidy the suggested list, delete anything you don&apos;t need, and use{' '}
    <strong>Import</strong> or <strong>Add new</strong> to complete it.
  </>
);

const StrategicThirdParty = ({
  orgId,
  loading,
  strategicThirdPartyList,
  strategicThirdPartyCategories,
  fetchStrategicThirdPartyCategories,
  fetchStrategicThirdParty
}) => {
  useEffect(() => {
    fetchStrategicThirdPartyCategories();
    fetchStrategicThirdParty(orgId);
  }, [orgId, fetchStrategicThirdPartyCategories, fetchStrategicThirdParty]);

  const cats = strategicThirdPartyCategories && strategicThirdPartyCategories[CLASS_NAME];
  const rows = strategicThirdPartyList && strategicThirdPartyList[CLASS_NAME];

  return strategicThirdPartyList && strategicThirdPartyCategories ? (
    <OrganisationMainSection
      title="Strategic Third Parties"
      tooltipContent={TOOLTIP_DETAIL}
      guidance={GUIDANCE}
      toolbarActions={
        cats ? (
          <StrategicThirdPartyActionBar strategicThirdPartyClass={CLASS_NAME} strategicThirdPartyCategories={cats} />
        ) : null
      }
      flowPrev="/organization/suppliers"
      flowNext="/organization/strategic-crisis-experts"
    >
      <Spin spinning={loading}>
        <StrategicThirdPartyClass
          surfaceOnly
          strategicThirdPartyList={rows}
          strategicThirdPartyClass={CLASS_NAME}
          strategicThirdPartyCategories={cats}
        />
      </Spin>
    </OrganisationMainSection>
  ) : (
    <PageLoader tip="Loading Strategic Third Parties..." />
  );
};

const mapStateToProps = state => ({
  orgId: orgIdSelector(state),
  strategicThirdPartyList: strategicThirdPartyListSelector(state),
  strategicThirdPartyCategories: strategicThirdPartyCategoriesSelector(state),
  loading: loadingStrategicThirdPartySelector(state)
});

const mapDispatchToProps = { ...actions };

export default connect(mapStateToProps, mapDispatchToProps)(StrategicThirdParty);
